export default __webpack_public_path__ + "static/media/img_aws-colorBkg.3f13d1c7.png";